import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';
import { fromMutationObserver } from '../utils';

@Directive({
    selector: '[ll-decorated-tab]',
})
export class LlDecoratedTabDirective implements OnInit, OnDestroy {
    constructor(private _element: ElementRef<HTMLElement>) {
        this._domElement = this._element.nativeElement;
        
    }

    @Input() private primaryColor = '#32a9f4';

    private _subMngr = new Subscription();

    private _domElement: HTMLElement;

    private readonly BASE_STYLE = `
        padding: 10px;
        border-bottom: 1px solid #D8D8D8;
        color: #616161;
        cursor: pointer;
    `

    ngOnInit(): void {
        this._domElement.setAttribute('style', this.BASE_STYLE)
        this._subMngr.add(fromMutationObserver(this._domElement, {attributes: true}).pipe(
            map(v => v[0]),
            filter(v => v?.attributeName === 'class'),
            tap(v => {
                const ele = v.target as HTMLElement;
                if (ele?.classList.contains('active-tab')) {
                    ele.style.borderBottom = `2px solid ${this.primaryColor}`;
                } else {
                    ele.style.borderBottom = '1px solid #D8D8D8'
                }
            })
        ).subscribe());
    }

    ngOnDestroy(): void {
        this._subMngr.unsubscribe();
    }
}